import React, {useEffect} from 'react';
import ReportUtils from "../../../../../utils/report-utils.js";

const ReportContent = ({data, tableColumns}) => {
    const rows = data ?? [];
    const columns = [
        {id: "dt_evento", className: "w-[10%]", renderCell: element => element.dt_evento ?? ""},
        {id: "tipoevento", className: "w-[12%]", renderCell: element => element.tipoevento ?? ""},
        {id: "conta", className: "w-[5%]", renderCell: element => element.conta ?? ""},
        {id: "descricao", className: "w-[10%]", renderCell: element => element.descricao ?? ""},
        {id: "usuario", className: "w-[8%]", renderCell: element => element.usuario ?? ""},
        {id: "setor", className: "w-[10%]", renderCell: element => element.setor ?? ""},
        {id: "dt_encerramento", className: "w-[10%]", renderCell: element => element.dt_encerramento ?? ""},
        {id: "el_observacao", className: "w-[15%] break-all", renderCell: element => element.el_observacao ?? ""},
        {id: "usuario_aceite", className: "w-[10%]", renderCell: element => (element.usuario_aceite === "SYSTEM" ? "SISTEMA" : element.usuario_aceite) ?? ""}
    ];
    const visibleColumns = columns.filter(column => tableColumns?.[column.id]?.visible !== false);

    useEffect(() => {
        if (!data) return;
        ReportUtils.createExportableTable(null, null, "Lista de eventos", "event-list-data");
    }, [data, tableColumns]);

    return (
        <>
            {visibleColumns.length === 0 && <div className="alert alert-info p-2 h6 text-center mt-[20px]!">Todas as colunas foram ocultadas.</div>}
            <table id="event-list-data" className={`table report-table table-fixed ${visibleColumns.length === 0 ? "hidden" : ""}`}>
                <thead className="thead-background print:table-row-group!">
                    <tr className="bg-[#f6f6f6] text-left">
                        {visibleColumns.map(column => <th key={column.id} className={column.className}>{tableColumns?.[column.id]?.label ?? column.id}</th>)}
                    </tr>
                </thead>
                <tbody className="bg-white">
                    {rows.map((element, index) => (
                        <tr key={index} className="print:!break-words print:!break-inside-avoid">
                            {visibleColumns.map(column => <td key={column.id} className={column.className}>{column.renderCell(element)}</td>)}
                        </tr>
                    ))}
                </tbody>
            </table>

            <div id="chart-tables"></div>
        </>
    );
};

export default ReportContent;